var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.host === 'growlib')?_c('div',[_c('Growlib')],1):_vm._e(),(_vm.host === 'yinhai')?_c('div',[_c('Yinhai')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }